import EditLocalGroupMemberDetailsPage from "./EditLocalGroupMemberDetailsPage";

export * from './types'

export default EditLocalGroupMemberDetailsPage;
